import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth, setPersistence, browserLocalPersistence } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getMessaging, getToken, onMessage, Messaging } from "firebase/messaging";

// Za mobil/Safari (Google redirect): postavi NEXT_PUBLIC_AUTH_DOMAIN=nosiva.ba u production.
// Potrebno: 1) Firebase Console → Authentication → Authorized domains: dodaj nosiva.ba
// 2) Google Cloud Console → Credentials → OAuth 2.0 Client → Redirect URIs: https://nosiva.ba/__/auth/handler
const firebaseConfig = {
  apiKey: "AIzaSyBG71LQkW7Rf2_pudvcymRzCHpBXNNdl2Q",
  authDomain: process.env.NEXT_PUBLIC_AUTH_DOMAIN || "nosiva-ba.firebaseapp.com",
  projectId: "nosiva-ba",
  storageBucket: "nosiva-ba.appspot.com", // ✅ ISPRAVLJENO
  messagingSenderId: "612000257188",
  appId: "1:612000257188:web:7996588519bdfc39dac231",
};

const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

export { app };
export const auth = getAuth(app);

// Set language to Bosnian for Firebase Auth emails
// Firebase uses ISO 639-1 language codes. "bs" is the standard code for Bosnian.
// If "bs" doesn't work, Firebase will fallback to default (English) or you can use "sr" (Serbian) as alternative
if (typeof window !== "undefined") {
  auth.languageCode = "bs"; // Bosnian language code (ISO 639-1)
  
  // Set persistence to local storage so users stay logged in across browser sessions
  // This ensures users are remembered even after closing the browser
  setPersistence(auth, browserLocalPersistence).catch((error) => {
    console.error("Error setting auth persistence:", error);
  });
}
export const db = getFirestore(app);
export const storage = getStorage(app);

// Firebase Cloud Messaging (FCM) - only available in browser
export async function getMessagingInstance(): Promise<Messaging | null> {
  if (typeof window === "undefined") return null;
  
  try {
    // Register service worker first
    if ('serviceWorker' in navigator) {
      try {
        const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js', {
          scope: '/firebase-cloud-messaging-push-scope'
        });
        console.log('Service Worker registered:', registration);
      } catch (swError) {
        console.warn('Service Worker registration failed:', swError);
        // Try to register without scope
        try {
          await navigator.serviceWorker.register('/firebase-messaging-sw.js');
        } catch (swError2) {
          console.error('Service Worker registration failed completely:', swError2);
          return null;
        }
      }
    }
    
    return getMessaging(app);
  } catch (error) {
    console.warn("Firebase Messaging not available:", error);
    return null;
  }
}

